<template lang="html">

<el-row :gutter="10">

    <el-alert
      title="设置【商家入驻收费】后，便于用户通过汽车网直接使用微信支付在线支付入驻费，请认真设置！"
      type="success">
    </el-alert>
    <a href="http://sxbkj.cn/W01">
      <img style="width:100%;height:31%;" src="static/ruzhu.jpg"></img>
    </a>
    <el-form>
        <el-col :span="8" v-for="(data,position) in datas" class="basic-margin">
            <el-card style="padding-bottom:20px;">
                <el-col :md="24" style="margin-top:10px;">
                    <el-input v-model="data.serviceName" :disabled="true" placeholder="请输入服务名"></el-input>
                    <span v-show="!data.serviceName" style="color:red;height:30px;">服务名不能为空！</span>

                    <el-col style="margin-top:10px;padding-left: 0px;margin-top:10px;">
                      <el-row>
                        <el-checkbox label="商家推广（首页/资讯/选车/商家板块）" :checked="true" disabled></el-checkbox>
                      </el-row>
                      <el-row>
                        <el-checkbox label="商品推广（首页/商家详情）" :checked="true" disabled></el-checkbox>
                      </el-row>
                      <el-row>
                        <el-checkbox label="独立商家页面" :checked="true" disabled></el-checkbox>
                      </el-row>
                      <el-row>
                        <el-checkbox label="电话一键拨号" :checked="true" disabled></el-checkbox>
                      </el-row>
                      <el-row>
                        <el-checkbox label="商家地址导航" :checked="true" disabled></el-checkbox>
                      </el-row>
                      <el-row>
                        <el-checkbox label="商家管理中心" :checked="true" disabled></el-checkbox>
                      </el-row>
                      <el-row>
                        <el-checkbox label="门店信息管理" :checked="true" disabled></el-checkbox>
                      </el-row>
                      <el-row>
                        <el-checkbox label="商品自主发布" :checked="true" disabled></el-checkbox>
                      </el-row>

                      <el-checkbox-group v-model="data.serviceTag" size="mini"  >
                          <el-row v-for="tag in data.serviceTag"  style="margin-top:5px;padding:0px;">
                              <el-checkbox  :label="tag" border></el-checkbox>
                          </el-row>
                      </el-checkbox-group>
                      <el-col v-if="data.inputVisible" style="width:170px;padding:0px;">
                        <el-input :ref="'advantage'+position"  v-model="data.inputValue" style="margin-right:5px;margin-top:5px;"  size="small" maxlength="15" placeholder="设置新优势点" @keyup.enter.native="handleInputConfirm(data)" @blur="handleInputConfirm(data)">
                        </el-input>
                      </el-col>
                      <el-button v-else  style="margin-left: 0px;margin-top:5px;" size="small" @click="showInput(data,'advantage'+position)">+ 添加优势点</el-button>
                    </el-col>
                    <el-col style="width:300px;padding:0px;margin-top:5px;">
                      <el-input v-model="data.servicePrice" min="0" type="number" size="small" placeholder="设置收费价格">
                        <template slot="append">元 / 年</template>
                      </el-input>
                    </el-col>
                    <el-col>
                      <div  style="color:red;height:30px;font-size:10px;margin-top:10px;">
                        <span v-show="!data.servicePrice">收费价格不能为空！</span>
                      </div>

                      <div style="color:#666;font-size:10px;margin-top:5px;">
                        设置为“0”时，该方案表示免费！
                      </div>
                    </el-col>
                </el-col>
            </el-card>
        </el-col>
        <el-col class="basic-margin">
            <el-button type="primary" @click="submit">保存立即生效</el-button>
        </el-col>
        <el-col class="basic-margin" :span="12">
          <h4><b>使用场景：</b></h4>
          <el-col :span="24">
            <img style="width:100%" src="static/ruzhufeiyong.png"></img>
          </el-col>
        </el-col>
    </el-form>
</el-row>

</template>

<script>

import Config from '@/framework/configs/Config'
import channelModel from '@/framework/models/channelModel'
export default {
  name: 'business-free-config',
  data: function () {
    return {
      channelId: null,
      selectItem: null,
      baseUrl: Config.baseUrl,
      baseImageUrl: Config.imageUrl,
      datas: []
    }
  },
  created: function () {
    // 获取用户信息
    let userInfo = JSON.parse(localStorage.userInfo)

    // 验证用户信息为空的情况
    if (!userInfo) {
      return
    }

    // 如果不是渠道不执行后面的内容
    if (userInfo.loginPath != 'channel') {
      return
    }

    // 初始化数据
    this.channelId = userInfo.id
    this.loadList()
  },
  methods: {
    handleInputConfirm: function (data) {
      // 获取输入框的值
      let inputValue = data.inputValue

      // 隐藏值
      data.inputVisible = false
      data.inputValue = ''

      // 验证非空的情况
      if (!inputValue) {
        return
      }

      // 设置新服务项
      data.serviceTag.push(inputValue)
    },
    submit: function () {
      let _this = this
      let datas = _this.datas

      for (var i = 0; i < datas.length; i++) {
        let data = datas[i]

        if (!/^\d+$/.test(data.servicePrice)) {
          this.$message({
            type: 'error',
            message: '价格必须是整数！'
          })
          return
        }

        if (data.servicePrice == null) {
          this.$message({
            type: 'error',
            message: '价格不能为空！'
          })
          return
        }
      }

      let json = JSON.stringify(_this.datas)

      let serviceLevelOption = JSON.parse(json)

      for (var i = 0; i < serviceLevelOption.length; i++) {
        let item = serviceLevelOption[i]
        delete item.inputValue
        delete item.allTag
      }

      let params = {
        channelId: _this.channelId,
        serviceLevelOption: JSON.stringify(serviceLevelOption)
      }

      let listener = {
        success: function (dataInfo) {
          _this.$message({
            type: 'success',
            message: '费用已生效！'
          })
        }
      }

      channelModel.updateServiceLevel(_this, params, listener)
    },
    loadList: function () {
      let _this = this
      let params = {
        id: _this.channelId
      }

      let listener = {
        success: function (dataInfo) {
          let datas = dataInfo.datas
          if (datas.serviceLevelOption) {
            _this.datas = JSON.parse(datas.serviceLevelOption)
          } else {
            let defaultTag = [{
              serviceName: '基础版',
              servicePrice: null,
              inputVisible: false,
              serviceTag: ['商家置顶推广', '代发商品', '代发活动']
            }, {
              serviceName: '升级版',
              servicePrice: null,
              inputVisible: false,
              serviceTag: ['商家置顶推广', '代发商品', '代发活动']
            }, {
              serviceName: '高级版',
              servicePrice: null,
              inputVisible: false,
              serviceTag: ['商家置顶推广', '代发商品', '代发活动']
            }]
            _this.datas = defaultTag
          }
        }
      }

      channelModel.selectChannelByID(_this, params, listener)
    },
    showInput: function (data, ref) {
      data.inputVisible = true
      this.$nextTick(function () {
        let advantageView = this.$refs[ref]
        advantageView[0].focus()
      })

      console.log(advantageView[0])
    }
  }
}

</script>
